import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './tour_detailsstyles.css';
import gilgitImg1 from '../assets/gilgit1.jpg';
import gilgitImg2 from '../assets/gilgit2.jpg';
import gilgitImg3 from '../assets/gilgit3.jpg';

const TourDetail3 = () => {
  const [activeImage, setActiveImage] = useState(0);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const navigate = useNavigate();

  const images = [gilgitImg1, gilgitImg2, gilgitImg3];

  const handleImageClick = (index) => {
    setActiveImage(index);
  };

  const handlePackageSelect = (packageData) => {
    const tourData = {
      ...packageData,
      tour_name: 'Explore the Majestic Gilgit'  // Add the tour name here
    };
    setSelectedPackage(tourData);
    navigate('/booking', { state: { packageData: tourData } });  // Pass the updated packageData
  };

  

  return (
    <div className="tour-details">
      <div className="tour-header">
        <h1>Explore the Majestic Gilgit</h1>
        <p><strong>Description:</strong> Discover the beauty and culture of Gilgit with our comprehensive tour package.</p>
      </div>

      {/* Overview Section */}
      <section className="overview">
        <h2>Overview</h2>
        <p>
          Gilgit is known for its breathtaking landscapes, rich history, and cultural heritage. 
          Our tour offers an immersive experience that combines natural beauty with cultural exploration. 
          You'll visit historic forts, serene lakes, and enjoy the local cuisine and traditions.
        </p>
      </section>

     

      {/* Gallery Section */}
      <section className="gallery">
        <h2>Gallery</h2>
        <div className="image-gallery">
          {images.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`Gilgit ${index + 1}`}
              onClick={() => handleImageClick(index)}
              className={index === activeImage ? 'active' : ''}
            />
          ))}
        </div>
      </section>

      {/* Pricing Section */}
      <section className="pricing">
        <h2>Pricing</h2>
        <div className="pricing-details">
          <div className="price-item">
            <h3>Standard Package</h3>
            <p><strong>Price:</strong> PKR 50,000 per person</p>

          <p>
          <strong>Detils:</strong>Accommodation in 3-star hotels, guided tours, and transportation in a private SUV. Breakfast and dinner included. Duration: 7 days.
          <br/>
          <strong>Visiting Spots:</strong> Karakoram Highway, Hunza Valley, Attabad Lake
          </p>        
        
            <button onClick={() => handlePackageSelect({
              name: 'Standard Package',
              price: 'PKR 50,000 per person',
              duration: '7 days',
              accommodation: '3-star hotels',
              transportation: 'Private SUV and local guides',
              facilities: [
                'Guided tours and cultural nights',
                'Breakfast, Lunch, and Dinner included'
              ],
              spots: ['Karakoram Highway', 'Hunza Valley', 'Attabad Lake']
            })} className="book-now-btn">Select Package</button>
          </div>

          <div className="price-item">
            <h3>Deluxe Package</h3>
            <p><strong>Price:</strong> PKR 75,000 per person</p>
            <p> <strong>Details:</strong> Accommodation in 5-star hotels, all-inclusive meals, private guided tours, and luxury transportation in a private SUV. Duration: 7 days.
            <br/>
            <strong>Visiting Spots:</strong> Karakoram Highway, Hunza Valley, Khunjerab Pass, Attabad Lake, Fairy Meadows
            </p>
          

           
            
            <button onClick={() => handlePackageSelect({
              name: 'Deluxe Package',
              price: 'PKR 75,000 per person',
              duration: '7 days',
              accommodation: '5-star hotels',
              transportation: 'Private SUV and local guides',
              facilities: [
                'All-inclusive meals',
                'Private guided tours and luxury transportation',
                'Exclusive cultural nights and special events',
                'Priority check-in and access to exclusive areas',
                'Additional guided tours and activities'
              ],
              spots: ['Karakoram Highway', 'Hunza Valley', 'Khunjerab Pass', 'Attabad Lake', 'Fairy Meadows']
            })} className="book-now-btn">Select Package</button>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials">
        <h2>Testimonials</h2>
        <blockquote>
          "Gilgit is a paradise on earth. The tour was exceptionally well-organized and exceeded all my expectations."
          <cite> - Hassan Raza</cite>
        </blockquote>
        <blockquote>
          "A memorable experience with stunning views and rich cultural experiences. Highly recommended!"
          <cite> - Ayesha Noor</cite>
        </blockquote>
      </section>

      {/* Map Section */}
      <section className="map">
        <h2>Map</h2>
        <iframe 
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11800907.345602548!2d72.42433488384488!3d35.59513433160286!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38e007ad29b6c531%3A0x1856b967f6b6cda2!2sGilgit%2C%20Gilgit-Baltistan%2C%20Pakistan!5e0!3m2!1sen!2s!4v1693385955453!5m2!1sen!2s"
          width="100%" 
          height="450" 
          style={{ border: 0 }} 
          allowFullScreen="" 
          loading="lazy" 
          title="Gilgit Map"
        />
      </section>

      {/* FAQs Section */}
      <section className="faqs">
        <h2>FAQs</h2>
        <details>
          <summary>What is included in the Gilgit tour package?</summary>
          <p>The package includes accommodation, meals, guided tours, and transportation within Gilgit.</p>
        </details>
        <details>
          <summary>What should I pack for the Gilgit trip?</summary>
          <p>We recommend packing comfortable clothing, warm layers, good walking shoes, and a camera to capture the stunning views.</p>
        </details>
        <details>
          <summary>Are there any additional costs?</summary>
          <p>Additional costs may include personal expenses, travel insurance, and any optional activities not included in the package.</p>
        </details>
      </section>

      <section className="contact-info">
        <h2>Contact Information</h2>
        <p>For more details or to book your tour, contact us at <a href="tel:+1234567890">(123) 456-7890</a> or email us at <a href="mailto:info@travelsite.com">info@travelsite.com</a>.</p>
      </section>
    </div>
  );
};

export default TourDetail3;
